<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="modalRemover"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalRemover"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="modalRemoverTitulo">
            Remover {{ tipo }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            id="closeModalClick"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="px-3 pb-3">
            Você tem certeza que deseja remover o {{ tipo }}: {{ descricao }} ?
          </p>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success fit-content"
              :disabled="loading"
              @click="confirmar"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Confirmando...</span>
              <span v-else>Confirmar</span>
            </button>
            <button
              type="button"
              class="btn btn-danger fit-content"
              data-dismiss="modal"
              aria-label="Close"
              id="closeModalClick"
            >
              <span aria-hidden="true">Cancelar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalRemover",
  props: {
    descricao: {
      type: String,
      default: "",
    },
    tipo: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirmar() {
      this.$emit("click", {
        props: {
          resultado: true,
        },
      });
    },
  },
};
</script>
